import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const BylineWrapper = styled.div`
  max-width: 650px;
  width: 95%;
  margin: 0 auto 1.5rem;
`;

const Byline = styled.p`
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: var(--offblack);
  text-align: center;
  margin-bottom: 0.25rem;
  a {
    color: var(--offblack);
  }
`;

const Bylines = ({ pubDate }) => {
  // constructing the publish date graph based on if there is a pubDate object
  // and whether that object has publishDate and updateDate
  let publishGraph;
  if (pubDate && pubDate.publishDate) {
    publishGraph = `Published ${pubDate.publishDate}`;
  }
  if (pubDate && pubDate.updateDate) {
    publishGraph += ` Updated ${pubDate.updateDate}`;
  }

  const pubGraph = publishGraph !== undefined
    ? <Byline className="bentonsanscond-n4">{publishGraph}</Byline>
    : null;

  return (
    <BylineWrapper className="byline__wrapper">
      <Byline className="bentonsanscond-n4">By Globe Staff</Byline>
      {pubGraph}
    </BylineWrapper>
  );
};

Bylines.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  ).isRequired,
  pubDate: PropTypes.shape({
    publishDate: PropTypes.string,
    updateDate: PropTypes.string,
  }),
};

Bylines.defaultProps = {
  pubDate: null,
};

export default Bylines;
